// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1Lql3","large":"styles_large__2cUT-"};